import BASEURLGESTTOR from '../api/gesttor'

export function curriculoCadastradoMensal () {
  return BASEURLGESTTOR.get('/dashboard/candidatos/novosCandidatos')
}

export function curriculoAnaliseDisc () {
  return BASEURLGESTTOR.get('/dashboard/candidatos/analiseDisc')
}

export function curriculosPorEstados () {
  return BASEURLGESTTOR.get('/dashboard/candidatos/curriculosPorEstado')
}

export function curriculosPorCidades () {
  return BASEURLGESTTOR.get('/dashboard/candidatos/curriculosPorCidade')
}

export function curriculosCompletosIncompletos () {
  return BASEURLGESTTOR.get('/dashboard/candidatos/curriculosCadastradosCompletosIncompletos')
}

export function curriculoEstatisticas () {
  return BASEURLGESTTOR.get('/dashboard/candidatos/estatisticas')
}

export function curriculosSituacaoMensal () {
  return BASEURLGESTTOR.get('/dashboard/candidatos/curriculosCompletosIncompletosPorMes')
}